module.exports = __webpack_public_path__ + "static/media/悬架转向及制动.c08b0b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/悬架转向及制动.png
// module id = 1715
// module chunks = 174